import { forwardRef } from "react";
function SvgRawFormativeIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#FFC400"
        d="M25.683 17.784a2.403 2.403 0 0 1-2.509-2.246 7.16 7.16 0 0 0-2.336-4.855 2.405 2.405 0 0 1-.158-3.396 2.402 2.402 0 0 1 3.394-.158 11.94 11.94 0 0 1 3.896 8.099 2.403 2.403 0 0 1-2.243 2.553l-.044.003Z"
      />
      <path
        fill="#FFC400"
        d="M25.683 17.784a2.404 2.404 0 0 1-2.51-2.246 7.16 7.16 0 0 0-2.335-4.855 2.405 2.405 0 0 1-.158-3.395 2.402 2.402 0 0 1 3.394-.159 11.94 11.94 0 0 1 3.896 8.1 2.403 2.403 0 0 1-2.287 2.555Z"
      />
      <path
        fill="#fff"
        d="m22.327 12.534-1.09-2.247 3.87-3.622a.328.328 0 0 1 .533.127l.538 1.464a.141.141 0 0 1-.029.145l-3.822 4.133Z"
      />
      <path
        fill="#fff"
        d="m22.326 12.534-1.09-2.246 3.871-3.623a.328.328 0 0 1 .533.127l.538 1.465a.141.141 0 0 1-.03.145l-3.822 4.132Z"
      />
      <path
        fill="#65D351"
        d="M22.568 11.306a2.4 2.4 0 0 1-1.73-.623 7.144 7.144 0 0 0-5.18-1.867 7.145 7.145 0 0 0-4.983 2.342 2.402 2.402 0 1 1-3.553-3.236 11.921 11.921 0 0 1 8.312-3.909c3.202-.15 6.27.957 8.64 3.116a2.404 2.404 0 0 1-1.506 4.177Z"
      />
      <path
        fill="#65D351"
        d="M22.569 11.306a2.399 2.399 0 0 1-1.73-.623 7.145 7.145 0 0 0-5.18-1.867 7.145 7.145 0 0 0-4.984 2.342 2.402 2.402 0 1 1-3.553-3.236 11.92 11.92 0 0 1 8.313-3.909c3.2-.15 6.27.957 8.64 3.116a2.404 2.404 0 0 1-1.506 4.177Z"
      />
      <path
        fill="#8088B7"
        d="M9.645 25.5a2.395 2.395 0 0 1-1.73-.623c-4.892-4.456-5.248-12.062-.793-16.955a2.403 2.403 0 1 1 3.553 3.236c-2.67 2.934-2.457 7.494.475 10.165a2.403 2.403 0 0 1-1.505 4.178Z"
      />
      <path
        fill="#8088B7"
        d="M9.645 25.501a2.396 2.396 0 0 1-1.73-.623c-4.892-4.456-5.248-12.063-.793-16.955a2.403 2.403 0 1 1 3.553 3.236c-2.67 2.934-2.457 7.493.475 10.165A2.403 2.403 0 0 1 9.645 25.5Z"
      />
      <path
        fill="#FF7C6E"
        d="M16.556 27.987a11.961 11.961 0 0 1-8.64-3.11 2.403 2.403 0 0 1 3.235-3.554c2.933 2.671 7.493 2.458 10.163-.475a2.404 2.404 0 1 1 3.554 3.236 11.966 11.966 0 0 1-8.312 3.903Z"
      />
      <path
        fill="#FFC400"
        d="M23.126 25.004a2.419 2.419 0 0 1-1.9-4.044 7.184 7.184 0 0 0 1.87-5.342 2.418 2.418 0 0 1 2.258-2.569c1.336-.085 2.535.925 2.621 2.258.213 3.3-.949 6.464-3.175 8.91a2.411 2.411 0 0 1-1.674.787Z"
      />
      <path
        fill="#FFC400"
        d="M23.126 25.005a2.416 2.416 0 0 1-1.901-4.043 7.185 7.185 0 0 0 1.872-5.342 2.418 2.418 0 0 1 2.256-2.57c1.336-.085 2.536.925 2.622 2.258.213 3.3-.949 6.464-3.175 8.91a2.411 2.411 0 0 1-1.674.787Z"
      />
      <path
        fill="#0BBEE6"
        d="M26.841 8.177c-.47.536-1.005.794-2.872 2.922-1.867 2.127-2.85 3.624-3.36 4.387-1.529 2.277-2.096 3.435-2.456 4.133-.36.697-.566 1.151-1.453 1.465-.887.314-1.915-.084-2.492-.873-.576-.788-3.046-3.64-3.505-4.255-.457-.615-.469-2.081.518-2.8.986-.72 2.14-.543 2.777.205l1.724 2.023c1.055-1.742 1.991-3.152 2.808-4.23 1.224-1.617 2.73-3.435 4.268-4.907.162-.155.76-.89 1.292-1.231.53-.342 1.555-.557 2.502.25 1.057.904.72 2.375.249 2.911Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawFormativeIcon);
export default ForwardRef;
